import cmp from './Certificates'

export default cmp
